"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portsToastStatusSelector = exports.isCreatingPortSelector = exports.isSavePromptVisibleSelector = exports.filteredPorts = exports.portsOptionsSelector = exports.portsSelector = void 0;
const portsSelector = (state) => {
    return state.ports.ports;
};
exports.portsSelector = portsSelector;
const portsOptionsSelector = (state) => {
    return state.ports.ports.map((port) => {
        return {
            label: port.name,
            value: port.id,
        };
    });
};
exports.portsOptionsSelector = portsOptionsSelector;
const filteredPorts = (state) => {
    return state.ports.filteredPorts;
};
exports.filteredPorts = filteredPorts;
const isSavePromptVisibleSelector = (state) => {
    return state.ports.isSavePromptVisible;
};
exports.isSavePromptVisibleSelector = isSavePromptVisibleSelector;
const isCreatingPortSelector = (state) => {
    return state.ports.isCreatingPort;
};
exports.isCreatingPortSelector = isCreatingPortSelector;
const portsToastStatusSelector = (state) => {
    return state.ports.portToastStatus;
};
exports.portsToastStatusSelector = portsToastStatusSelector;
